<div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="row gx-0">
        <div class="col-12 col-md-6 p-0 order-md-0 order-1">
            <div class="h-100">
                <div class="h-100 overflow-hidden">
                    <img class="min-w-100 min-h-100 img-fluid item-md-center" src="/assets/images/our_showroom.jpg" alt="" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-5 d-flex flex-column justify-content-center px-lg-12 px-md-7 ps-0 pe-9 pt-10 pt-md-0 mb-md-0 mb-5">
            @if (titleStyle === 'secondary') {
                <h3 class="text-uppercase fs-12 fw-700 font-secondary ls-3 mb-5">
                    {{ 'OUR_SHOWROOM.title' | translate }}
                </h3>
            }
            @if (titleStyle === 'primary') {
                <h3 class="fs-29 fw-700 mb-4">{{ 'OUR_SHOWROOM.title' | translate }}</h3>
            }
            <p class="mb-5 lh-29">{{ 'OUR_SHOWROOM.content' | translate }}</p>
            <app-button color="secondary" [url]="'/our-showroom' | localize">{{ 'BUTTONS.more' | translate }}</app-button>
        </div>
    </div>
</div>
